import React, { useState } from "react";
import "leaflet/dist/leaflet.css";
import { Link } from "react-router-dom";
import PiChart from "./PiChart";
import Chart from "react-apexcharts";

const SaleAnimal = () => {
  const handleLogout = (event) => {
    event.preventDefault();
    sessionStorage.clear("token");
    window.location = "/login";
  };

  const [chartData, setChartData] = useState({
    options: {
      chart: {
        id: "bar-chart",
        background: "#f4f4f4",
        toolbar: {
          show: false,
        },
      },
      xaxis: {
        categories: ["Expected/Actual"],
        labels: {
          style: {
            fontSize: "14px",
          },
        },
      },
      yaxis: {
        title: {
          text: "Values",
          style: {
            fontSize: "14px",
          },
        },
        labels: {
          style: {
            fontSize: "14px",
          },
        },
      },
      colors: ["#6d78ad"],
      title: {
        text: "Expected vs Actual",
        align: "center",
        style: {
          fontSize: "20px",
        },
      },
    },
  });

  return (
    <div>
      <div className="navbar">
        <a href="/home">
          <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
        </a>
        <button className="logout-btn" onClick={handleLogout}>
          Log out
        </button>
      </div>
      <div className="thailand-market-container">
        <div className="thailand-market-grid">
          <Link
            className="global-market-menuitem"
            to="/thailand-market/quantity-animal"
          >
            ปริมาณตัวสัตว์
          </Link>
          <Link
            className="global-market-menuitem"
            to="/thailand-market/demand-animal"
          >
            ความต้องการอาหารสัตว์
          </Link>
          <Link
            className="global-market-menuitem"
            to="/thailand-market/share-market"
          >
            ส่วนแบ่งการตลาดอาหารสัตว์
          </Link>
          <Link
            className="global-market-menuitem"
            to="/thailand-market/sale-animal"
          >
            ยอดขายอาหารสัตว์ CPF
          </Link>
        </div>
        <Chart
          options={chartData.options}
          series={chartData.series}
          type="bar"
        />
      </div>
    </div>
  );
};

export default SaleAnimal;
